<section class="save-search is-flex-column">
  <br/>
  <form (ngSubmit)="onSubmit()" [formGroup]="saveSearchForm" [class.has-error]="hasError.duplicateName">
    <div class="form-group">
      <label for="save-search-name" translate="drawer.save-search.label"></label>
      <app-input inputId="input-save-search" [parentFormGroup]="saveSearchForm" [formControl]="saveSearchForm.get('name')"
      [isFullWidth]="true" placeholder="{{'drawer.save-search.placeholder' | translate}}"></app-input>
      <span class="has-error" *ngIf="hasError.duplicateName" translate="drawer.save-search.error-duplicate-name"></span>
        <app-checkbox [text]="'my-remax.saved-searches.enable-notifications-long' | translate"
        id="saveSearchNotificationCheckbox" [formControl]="saveSearchForm.get('notification')"
        [parentFormGroup]="saveSearchForm" [disabledActiveText]="true" [inverted]="true"></app-checkbox>
    </div>

    <button id="saveSearch-button-save" type="submit" [disabled]="saveSearchForm.invalid" class="btn btn-primary btn-full-sized" translate="drawer.save-search.save"
      angulartics2On="click" [angularticsProperties]="'_save_search' | listingTypeAnalyticsTag | async"
    ></button>
  </form>
  <button id="saveSearch-button-cancel" type="button" class="btn btn-fake btn-full-sized" (click)="closed.emit()" style="float: right;" translate="drawer.save-search.cancel"></button>
  <h4 *ngIf="savedSearches.length" translate="drawer.save-search.update-existing"></h4>
  <div class="saved-search-list">
    <app-saved-search *ngFor="let search of savedSearches;" [savedSearch]="search" [enableDeleteSearch]="false" [parentComponent]="SavedSearchLocationType.SAVE_SEARCH"
    (onSavedSearchClick)="updateSavedSearch($event)"></app-saved-search>
  </div>
</section>
<app-login-reminder [isModal]="true"></app-login-reminder>
